module.exports = __webpack_public_path__ + "img/kochava.70afd44.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/integrations/kochava.png
// module id = 3iqM
// module chunks = 39 44